module.exports = __webpack_public_path__ + "static/media/iosr_logo.567f6429.jpeg";